/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  exercise: {
    name: 'Exercice',
    rest: 'Reposez-vous un instant.',
    pause: 'Vous êtes en pause',
    pauseMessage:
      'Prenez votre temps et quand vous êtes prêt appuyez sur le bouton ci-bas.',
    complete: 'Exercice terminé.',
    end: 'Félicitations! Vous voici à la fin de votre séance d’exercices. Continuez votre bon travail : la persévérance est une condition essentielle à votre réussite.',
    empty:
      'Aucun plan d’intervention n’a encore été créé pour vous. Consultez votre clinicien(ne) pour activer votre profil d’exercices.',
  },
};
